import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar"; 
import "./MainLayout.css";

const MainLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className="layout">
      {/* Overlay ปิด Sidebar เมื่อคลิกข้างนอก */}
      {isSidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

      {/* Header (ส่ง toggleSidebar ไปให้ Header) */}
      <Header isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      {/* ✅ Sidebar ต้องรับ toggleSidebar ไปใช้ */}
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <main className="content">{children}</main>

      {/* <footer className="footer">
        <Footer />
      </footer> */}
    </div>
  );
};

export default MainLayout;
